import store from "../../store"
import { Network } from ".."
import { clearLocalStorage } from "../helperFunctions"
import manageLocalStorage from "../localStorage"

export default async function becomeUser({ adminUser, user, history }) {
	manageLocalStorage({ action: "SET", key: "admin-user", value: adminUser })
	clearLocalStorage({ type: "employee" })

	const url = `user/${user?.user ? user?.user?.id : user?.id}/login`
	const token = adminUser.token
	const response = await Network.AxiosWrapper({ method: "POST", target: url, token })

	user = response?.data
	user = await store.getUser({ user, history, login: true })

	const message = `Now logged in as ${user.firstName} ${user.lastName}.`
	store.setNotification("notification", true, { msg: message })
}
